import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-md mx-auto mt-10" }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 p-2" }, " 購入した店舗 ", -1)
const _hoisted_4 = { class: "bg-white p-2" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 p-2" }, " 購入した商品 ", -1)
const _hoisted_7 = { class: "bg-white p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.purchaseStore?.name), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.purchaseItem?.name), 1)
    ])
  ]))
}